import alt from '../alt';
import ProductBrowseActions from './ProductBrowseActions';

const originalResultCount = 25;

class ProductBrowseStore {
	constructor() {
		let decoded, decodedCriteria;
		let info = {
			Category: 0,
			SearchTerms: [],
			isPageSearch: false,
			currentPage: 1,
			resultCount: originalResultCount
		}
		this.breadcrumbList = [];
		if (window.location.hash.replace('#', '').length > 0) {
			let decoded = decodeURIComponent(window.location.hash).replace('#', '');
			if (window.location.hash.replace('#', '').length > 0) {
				decoded = decodeURIComponent(window.location.hash).replace('#', '');
				if (decoded.length > 0) {
					decoded = decoded.split('|');
					decodedCriteria = decoded[0].split(',');

					if (decodedCriteria.length >= 1 && decodedCriteria[0] !== ''){
							info.SearchTerms = decodedCriteria;
							info.isProductSearch = true;
					}
					if (decoded[1] !== undefined) {
						if (decoded[1].length > 0) {
							info.Category = decoded[1]
						}
					}
					if (decoded[2] !== undefined && decoded[2].length > 0) {
							info.currentPage = typeof parseInt(decoded[2]) === "number" ? parseInt(decoded[2]) : 1;
							info.resultCount = info.currentPage == 1 ? originalResultCount : info.currentPage * originalResultCount;
					}
				}
			}
		}
		this.state = {
			CategoryList: [],
			ProductList: [],
			SearchTerms: info.SearchTerms,
			hasResults: false,
			isLoading: false,
			prodLoaded: false,
			resultCount: info.resultCount,
			isProductSearch: false,
			canSearch: true,
			isPageSearch: info.isProductSearch,
			currentPage: info.currentPage,
			SearchField: '',
			currentCategoryID: info.Category,
			categoryInfo: {
				selectedParentCategory: info.Category,
				selectedParentCategoryName: '',
				selectedCategoryName: '',
				selectedCategoryID: info.Category
			},
			breadcrumb: []
		};
		this.bindListeners({
			categoriesChanged: ProductBrowseActions.CATEGORIES_SUCCESS,
			categoriesLoadFailed: ProductBrowseActions.CATEGORIES_FAILURE,
			productsChanged: ProductBrowseActions.PRODUCTS_SUCCESS,
			productsLoadFailed: ProductBrowseActions.PRODUCTS_FAILURE,
			productsPageChanged: ProductBrowseActions.MORE_PRODUCTS_SUCCESS,
			resetAll: ProductBrowseActions.RESET_ALL,
			initialSetup: ProductBrowseActions.INITIAL_SETUP,
			setParentCategory: ProductBrowseActions.SET_PARENT_CATEGORY
		});
	}

	categoriesChanged(categories) {
		this.setState({
			CategoryList: categories.categories
		});
	}

	categoriesLoadFailed(message) {
		this.setState({
			CategoryList: [{Error: message}],
		});
	}

	productsChanged(productData) {
		this.setState({
			ProductList: productData.products.length > 0 ? productData.products : [],
			canSearch: productData.products.length < this.state.resultCount ? false : true,
			isLoading: false,
			prodLoaded: true,
			hasResults: productData.products.length > 0 ? true : false,
			isPageSearch: false,
			currentPage: 1,
			resultCount: originalResultCount,
			searchTerms: productData.sentData.searchTerm,
			currentCategoryID: productData.sentData.categoryID
		})
	}

	productsLoadFailed(message) {
		this.setState({
			ProductList: [{Error: message}],
			isLoading: false,
			prodLoaded: true,
			hasResults: false,
			canSearch: false,
			isPageSearch: false,
			currentPage: 1,
			resultCount: originalResultCount
		});
	}

	productsPageChanged(products) {
		let ProductList = this.state.ProductList;
		if (products.length > 0 || this.state.ProductList > 0) {
			this.setState({
				ProductList: ProductList.concat(products),
				canSearch: products.length < this.state.resultCount ? false : true,
				isLoading: false,
				hasResults: true,
				isPageSearch: false,
				currentPage: this.state.currentPage + 1,
				resultCount: originalResultCount
			})
		} else {
			this.setState({
				isLoading: false,
				hasResults: false,
				canSearch: false,
				isPageSearch: false,
				currentPage: this.state.currentPage,
				resultCount: originalResultCount
			})
		}
	}

	resetAll(){
		this.setState({
			SearchTerms: [],
			currentCategoryID: 0,
			currentPage: 1,
			isLoading: true,
			prodLoaded: false,
			hasResults: true,
			canSearch: true,
			ProductList: [],
			breadcrumb: [],
			categoryInfo: {
				selectedParentCategory: 0,
				selectedParentCategoryName: '',
				selectedCategoryName: '',
				selectedCategoryID: 0
			}
		})
	}

	initialSetup(callback) {
		callback()
		this.setState({
			resultCount: originalResultCount
		})
	}

	returnCategoryDescription(categoryList, catCode) {
		for (let pc = 0; pc < categoryList.length; pc++){
			if (categoryList[pc].code !== catCode && categoryList[pc].items.length > 0){
				this.returnCategoryDescription(categoryList[pc].items, catCode);
			} else if (categoryList[pc].code === catCode) {
				if (categoryList[pc].parent != null)
					this.returnCategoryDescription(this.state.CategoryList, categoryList[pc].parent);
				this.breadcrumbList.push({CategoryName: categoryList[pc].description, CategoryID: categoryList[pc].code})
				this.setState({
					breadcrumb: this.breadcrumbList
 				});
			}
		}
	}

	setParentCategory(CategoryID){
		this.breadcrumbList = [];
		this.returnCategoryDescription(this.state.CategoryList, CategoryID);
	}
}

export default alt.createStore(ProductBrowseStore, 'ProductBrowseStore');



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/ProductBrowseStore.js